import { Box, Loader } from "@tm/components"

export function TotalsLoader() {
    return (
        <Box alignSelf="flex-end">
            <Loader size="small" />
        </Box>
    )
}
